import { find } from 'lodash';

import { isRidgeCap } from '@/components/modals/SubmitOrder/constants';
import { OrderItemWrapper } from '@/components/modals/SubmitOrder/types';
import { PriceBookEntryVm, ProposalItemVm } from '@/types';

/**
 * Get ridge cap order item for displaying it in a ridge cap section
 * @param selectedAsphaltShingle Selected asphalt shingle
 * @param selectedEquipment Selected equipment (converted from Proposal)
 * @param allPriceBookEntries All price book entries (fetched from SF)
 * @param proposalItems Proposal items of the related proposal (created and fetched from SF)
 * @returns Ridge cap order item or null
 */
export const getSelectedRidgeCap = (
  selectedAsphaltShingle: OrderItemWrapper | null,
  selectedEquipment: OrderItemWrapper[],
  allPriceBookEntries: PriceBookEntryVm[],
  proposalItems: ProposalItemVm[],
): OrderItemWrapper | null => {
  const ridgeCapFromProposal = find(selectedEquipment, e => isRidgeCap(e));

  if (ridgeCapFromProposal) {
    return ridgeCapFromProposal;
  }

  const ridgeCapFromPriceBook = find(
    allPriceBookEntries,
    pbe => pbe.product.id === selectedAsphaltShingle?.priceBookEntry?.product?.dependentProductId,
  );

  if (!ridgeCapFromPriceBook) {
    return null;
  }

  const proposalItem =
    find(proposalItems, pi => pi.product.id === ridgeCapFromPriceBook.productId) ?? null;

  return {
    orderItem: {
      quantity: 0,
      productId: ridgeCapFromPriceBook.productId,
      description: null,
      numberOfBundles: null,
      numberOfSquares: null,
      linearFeetValue: null,
      quantityByDesign: 0,
      quantityOfOverage: 0,
      totalOutputKw: null,
      totalOutputW: null,
    },
    priceBookEntry: ridgeCapFromPriceBook,
    proposalItem: proposalItem,
  };
};

export const product = {
  id: 'asd123',
  name: 'lorem name',
  portalName: 'dolor portal name',
  model: 'qwe',
  output: 312,
  isCustom: true,
  sortingOrder: 1,
  isPreSelected: true,
  type: 1,
  isConfigurableQuantity: true,
  family: 0,
  line: 1,
  rooferMeasurement: 0,
  shipmentMeasurement: 0,
  asphaltShingleColor: 'sit color',
  dependentProductId: 'amet124',
  dependentProductMaxQuantity: 12,
  dependentProductMinQuantity: 3,
  squareToQuantityRatio: 4,
  bundleToQuantityRatio: 5,
  linearFeetToQuantityRatio: 6,
  description: null,
  rooferCanIncreaseQuantity: true,
  rooferCanDecreaseQuantity: true,
  isProductAvailable: null,
  isAddOn: null,
};

export const orderItem = {
  orderItem: {
    description: 'Lorem ipsum dolor sit',
    linearFeetValue: 5,
    numberOfBundles: 2,
    numberOfSquares: 4,
    productId: 'lorem-123',
    quantity: 1,
    quantityByDesign: 5,
    quantityOfOverage: 6,
    totalOutputKw: 12,
    totalOutputW: 44,
    isInventory: true,
  },
  priceBookEntry: {
    name: 'Order item name',
    priceBookId: '213id',
    productId: '456id',
    asphaltShingleColor: 'lorem color',
    unitPrice: 112,
    minQuantity: 1,
    discountAmount: 4,
    quantityDiscountThreshold: 3,
    product,
    rooferCanIncreaseQuantity: false,
    rooferCanDecreaseQuantity: false,
    isProductAvailable: null,
  },
  proposalItem: {
    id: '',
    proposalId: '',
    description: '',
    quantity: 0,
    quantityByDesign: 0,
    quantityOfOverage: 0,
    numberOfBundles: 0,
    numberOfSquares: 0,
    equipmentPrice: 0,
    servicesPrice: 0,
    unitPrice: 0,
    totalOutputKw: 0,
    totalOutputW: 0,
    product,
  },
};
